import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const openproject = defineConnector({
  identifier: "openproject",
  name: "OpenProject",
  tagLine: "Open source project management",
  logo,
  protocol: "http",
  tags: ["productivity", "engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://.*\\.openproject\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: "apikey",
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your OpenProject instance, go to **My Account > Access Tokens**, and generate an API token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "OpenProject host",
          placeholder: "my-org.openproject.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v3/users/me`,
  },
});
